module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n    "), (_vm.inputRequire) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.labelId,
      "type": _vm.inputType,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.changeValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3397520b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-3397520b"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcInput.vue
// module id = 1025
// module chunks = 1